import { type ReactElement, useCallback, useRef } from 'react';

import { Box } from 'components/Box/Box';
import { BodySmall } from 'components/Text/BodySmall';
import { useLatest } from 'hooks/useLatest';
import { useElementReachedEffect } from 'hooks/viewport/useElementReachedEffect';
import { useI18n } from 'i18n/hooks/useI18n';
import { ListingViewAtsApplicationForm } from 'modules/listing/components/ListingView/AtsApplicationForm/ListingViewAtsApplicationForm';

type Props = {
  applyText: string | null;
  applicationForm: ReactElement<typeof ListingViewAtsApplicationForm>;
  onReach: (() => void) | null;
};

export function ListingViewApplyAts({
  applyText,
  applicationForm,
  onReach,
}: Props) {
  const { i18n } = useI18n();
  const ref = useRef<HTMLDivElement>(null);

  const stableOnReachRef = useLatest(onReach);
  useElementReachedEffect({
    ref,
    onReach: useCallback(() => {
      stableOnReachRef.current?.();
    }, [stableOnReachRef]),
  });

  return (
    <div ref={ref}>
      {applyText && (
        <BodySmall>
          <strong>{i18n('Instructions')}:</strong>{' '}
          <span
            dangerouslySetInnerHTML={{
              __html: applyText,
            }}
          />
        </BodySmall>
      )}

      <Box mt={48}>{applicationForm}</Box>
    </div>
  );
}
